var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3143_142021)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55-2h-76v28h76V-2z",
    fill: "url(#paint0_linear_3143_142021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.322 9.898a2.62 2.62 0 0 1 1.664.602.258.258 0 0 0 .351-.006l.475-.474a.242.242 0 0 0 .073-.18.238.238 0 0 0-.085-.175 3.826 3.826 0 0 0-1.28-.705l.15-.697a.24.24 0 0 0-.051-.205.25.25 0 0 0-.194-.09h-.927a.254.254 0 0 0-.158.054.247.247 0 0 0-.088.14l-.135.62c-1.235.06-2.28.659-2.28 1.887 0 1.063.863 1.519 1.776 1.834.864.316 1.32.432 1.32.877 0 .444-.456.724-1.128.724a2.507 2.507 0 0 1-1.753-.675.254.254 0 0 0-.352 0l-.516.495a.244.244 0 0 0-.056.271c.013.03.032.058.056.08.42.39.933.668 1.492.81l-.139.648a.248.248 0 0 0 .136.276.26.26 0 0 0 .108.027h.934a.253.253 0 0 0 .248-.194l.134-.622c1.475-.093 2.375-.869 2.375-2.012 0-1.051-.9-1.494-1.995-1.858-.624-.222-1.164-.373-1.164-.83 0-.456.505-.622 1.009-.622z",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3143_142021",
    x1: -21,
    y1: 12,
    x2: 55,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D64B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3143_142021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    rx: 4,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashapp);
export default __webpack_public_path__ + "static/media/cashapp.1d5810d5da5217c1a5b8d222195791c2.svg";
export { ForwardRef as ReactComponent };